import { render } from "./ConsiliaDetailArticle.vue?vue&type=template&id=159d94a0&scoped=true"
import script from "./ConsiliaDetailArticle.vue?vue&type=script&lang=js"
export * from "./ConsiliaDetailArticle.vue?vue&type=script&lang=js"

import "./ConsiliaDetailArticle.vue?vue&type=style&index=0&id=159d94a0&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159d94a0"]])

export default __exports__